import { X, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function UpgradeModal({ isOpen, onClose, message, currentPlan }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!isOpen) return null;

  // Translate the error message from backend
  const translateMessage = (msg) => {
    if (!msg) return '';
    
    // Customer limit messages
    if (msg.includes('Customer limit reached')) {
      return t('upgradeModal.customerLimit');
    }
    // Project limit messages
    if (msg.includes('Project limit reached')) {
      return t('upgradeModal.projectLimit');
    }
    // Automatic invoices messages
    if (msg.includes('Automatic invoice') || msg.includes('only available for Basic and Pro')) {
      return t('upgradeModal.automaticInvoices');
    }
    // Tax overview messages
    if (msg.includes('Tax overview') || msg.includes('only available for Pro')) {
      return t('upgradeModal.taxOverview');
    }
    
    // Fallback: return original message
    return msg;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X className="h-6 w-6" />
        </button>

        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-emerald-100 mb-4">
            <Zap className="h-6 w-6 text-emerald-600" />
          </div>

          <h3 className="text-xl font-bold text-gray-900 mb-2">{t('upgradeModal.title')}</h3>
          
          <p className="text-gray-600 mb-1">{translateMessage(message)}</p>
          
          <p className="text-sm text-gray-500 mb-6">
            {t('upgradeModal.currentPlan')} <span className="font-semibold capitalize">{currentPlan}</span> {t('upgradeModal.plan')}.
          </p>

          <div className="space-y-3">
            <button
              onClick={() => {
                onClose();
                navigate('/pricing');
              }}
              className="w-full bg-emerald-600 text-white py-2 px-4 rounded-lg hover:bg-emerald-700 font-semibold transition-colors"
            >
              {t('upgradeModal.viewPricing')}
            </button>
            <button
              onClick={onClose}
              className="w-full bg-gray-100 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-200 font-semibold transition-colors"
            >
              {t('upgradeModal.maybeLater')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpgradeModal;